export enum LoginFormFields {
    USERNAME = 'username',
    PASSWORD = 'password',
}

export type LoginForm = {
    [key in LoginFormFields]: string;
}

/**
 * 
 * @example ```json
{
    "login": "webshop.test1",
    "jwtToken": "token",
    "identification": {
        "anrede": "Herr",
        "branche": "BR20",
        "comEmail": true,
        "comTelefon": true,
        "contactNo": "KT1945518",
        "email": "jalschbach@juris.de",
        "fachanwaltschaft": [
            "FAW:GWRS",
            "FAW:SOZR",
            "FAW:AR"
        ],
        "firmenname": "Testfirma",
        "iban": null,
        "interessen": [
            "INT:BEAMTENR",
            "INT:WETTB",
            "INT:AR"
        ],
        "land": "DEU",
        "loginName": "",
        "mitgliedschaften": [
            "ARGE:VERWRECHT",
            "ARGE:ARBEITSRECHT"
        ],
        "mobil": "(0049) 555 / 12345678",
        "nachname": "User - Arbeitsrecht",
        "nr": "11",
        "ort": "Saarbrücken",
        "payType": null,
        "plz": "66121",
        "position": null,
        "rechnungsEmail": "",
        "rechtsform": "",
        "strasse": "Am Römerkastell",
        "telefon": "(0049)  / 4535",
        "titel": "Dipl. Inf.",
        "vorname": "Test",
        "web": "www.juris.de"
    }
}
```
 */
export interface LoginResponse {
    identification: {
        anrede: string,
        branche: string,
        comEmail: boolean,
        comTelefon: boolean,
        comTracking: boolean,
        contactNo: string,
        email: string,
        fachanwaltschaft: string[],
        firmenname: string,
        iban: string,
        interessen: string[],
        land: string,
        loginName: string,
        mitgliedschaften: string[],
        mobil: string,
        nachname: string,
        nr: string,
        ort: string,
        payType: string,
        plz: string,
        position: string,
        rechnungsEmail: string,
        rechtsform: string,
        strasse: string,
        telefon: string,
        titel: string,
        vorname: string,
        web: string
    },
    jwtToken: string,
    login: string,
    status?: number;
}

export enum LoginStatusCode {
    LOGINSUCCESSFUL = 200,
    LOGINFAILED = 401,
    LOGINFORBIDDENTOBUY = 403,
    SERVERERROR = 500,
}

export default interface LoginProviderProps {
    key?: boolean;
}